export default "__VITE_ASSET__7jSs9Too__"